import React from 'react';

import { ConvertrForm } from 'Components/molecules/ConvertrForm';

export const getConvertrForm = (ConvertrFormData) => {
  if (ConvertrFormData && ConvertrFormData.whitepaperId) {
    return (
      <ConvertrForm
        {...ConvertrFormData}
      />
    );
  }

  return false;
};
